export const messages = {
  dialogTitle: 'Export Options',
  exportButton: 'Export',
  exportNonPII: 'Export Non-PII',
  exportAllPII: 'Export All PII',
  downloadPending: 'Report export requested. You’ll be notified by email once it’s ready.',
  downloadSuccess: 'The report has been downloaded successfully.',
  error: 'Something went wrong while exporting. Please try again.',
  piiCautionTitle: 'Caution',
  piiCautionText:
    'You are downloading Personally Identifiable Information (PII). Handle this sensitive data with care and ensure compliance with privacy and data protection laws.',
  downloadPageTitle: 'Download',
  downloadTitle: 'Download Audience Report',
  downloadSubtitle: 'If the download hasn’t started, click the button below',
  loadingExportMessage: 'Exporting your report...',
};

export const AUDIENCE_EXPORT_DEFAULT_NAME = 'unknown_audience';

export const PRODUCTS_SECTION_INFO_TEXT =
  'Members who have purchased any product in the selected groups will be included in eligibility calculation (products are eligible from group A or group B).';
